import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import moment from "moment";
import { formatMoney } from "../../../../helpers/formatter";
import styles from "../../LoanOffer/LoanOffer.module.scss";
import { Button } from "antd";
import ModalContainer from "../../ModalContainer";
import React, { Dispatch, SetStateAction, useState } from "react";
import useGetThirdPartySalaryInformation from "../../../../custom-hooks/useGetThirdPartySalaryInformation";
import Paginator from "../../../../components/Pagination/Pagination.component";
import { IThirdPartyInfoPayloadProp } from "../Disburse/CreditAnalysis/DisbursementSummary/DisbursementSummary";
import { BASE_URL } from "../../../../appConstants";
import { getBlobData } from "../../../../newApis/dotNetApiMethods";

interface ISalary {
  id: number;
  bankCode: string;
  accountNumber: string;
  paymentDate: string;
  amount: number;
}

interface ISalaryInformation {
  onClose: () => void;
  customerThirdPartySalaryInfoPrestate: IThirdPartyInfoPayloadProp;
  setCustomerThirdPartySalaryInfoPrestate: Dispatch<
    SetStateAction<IThirdPartyInfoPayloadProp>
  >;
  isDownloadable: boolean;
}

const SalaryInformation = ({
  customerThirdPartySalaryInfoPrestate,
  onClose,
  setCustomerThirdPartySalaryInfoPrestate,
  isDownloadable,
}: ISalaryInformation) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const {
    data: thirdPartySalaryInfo,
    isLoading: isLoadingThirdPartySalaryInfo,
  } = useGetThirdPartySalaryInformation(customerThirdPartySalaryInfoPrestate);

  const handlePaginationChange = (pageNumber: number) => {
    setCustomerThirdPartySalaryInfoPrestate((prev) => ({
      ...prev,
      Page: pageNumber,
    }));
  };

  const onDownload = async () => {
    setIsDownloading(true);
    const downloadUrl =
      BASE_URL +
      `/account/loan_disbursement/customer_third_party_salary_history_document?CustomerId=${customerThirdPartySalaryInfoPrestate?.CustomerId}&AggregatorId=${customerThirdPartySalaryInfoPrestate?.AggregatorId}`;
    try {
      const response = await getBlobData(downloadUrl);

      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = `salary information${new Date().toISOString()}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.log("Unable to download document. Contact admin", error.message);
    } finally {
      setIsDownloading(false);
    }
  };

  let RenderedComponent = null;
  if (isLoadingThirdPartySalaryInfo) {
    RenderedComponent = <p>Loading...</p>;
  } else if (thirdPartySalaryInfo?.data?.length === 0) {
    RenderedComponent = <p>No salary information</p>;
  } else {
    RenderedComponent = (
      <div className="d-flex flex-column w-full">
        <MDBTable
          responsive
          minimal="true"
          striped
          bordered
          hover
          id="table-to-xls"
        >
          <MDBTableHead>
            <tr>
              <th>S/N</th>
              <th>Amount</th>
              <th>Account Number</th>
              <th>Payment Date</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {thirdPartySalaryInfo?.data?.map(
              (salary: ISalary, index: number) => (
                <tr key={salary.id}>
                  <td>{index + 1}</td>
                  <td>{formatMoney(salary?.amount)}</td>
                  <td>{salary?.accountNumber}</td>
                  <td>{moment(salary.paymentDate).format("DD-MMM-YYYY")}</td>
                </tr>
              ),
            )}
          </MDBTableBody>
        </MDBTable>

        <Paginator
          size={thirdPartySalaryInfo?.pageSize}
          page={thirdPartySalaryInfo?.page}
          count={thirdPartySalaryInfo?.totalCount}
          changeCurrentPage={(value: number) => handlePaginationChange(value)}
        />
      </div>
    );
  }

  return (
    <ModalContainer height={50}>
      <h3 className="d-flex justify-content-center mb-2">
        Customer Salary Information
      </h3>
      <div className="d-flex justify-content-between">{RenderedComponent}</div>
      <div style={{ position: "absolute", right: "10px", top: "10px" }}>
        {isDownloadable ? (
          <Button
            className={styles.download_btn}
            onClick={onDownload}
            loading={isDownloading}
          >
            Download
          </Button>
        ) : null}
        <Button className={styles.view_offer_btn} onClick={onClose}>
          Close
        </Button>
      </div>
    </ModalContainer>
  );
};

export default SalaryInformation;
